/**
 * This list is for both sanctioned countries AND non-payable countries or territories.
 */
export const RESTRICTED_COUNTRIES_LIST = [
  'CUB',
  'IRN',
  'KAZ',
  'PRK',
  'LBY',
  'MMR',
  'RUS',
  'SSD',
  'SDN',
  'SYR',
  'UKR',
  'BLR',
  'VEN',
  'AFG',
  'ALB',
  'ASM',
  'ATA',
  'BHS',
  'BRB',
  'BWA',
  'BFA',
  'BDI',
  'CPV',
  'KHM',
  'CAF',
  'COD',
  'DOM',
  'SLV',
  'ERI',
  'ETH',
  'GHA',
  'GUM',
  'GTM',
  'GNB',
  'GUY',
  'HTI',
  'HND',
  'IRQ',
  'JAM',
  'JOR',
  'LBN',
  'MAC',
  'MLI',
  'MDA',
  'MAR',
  'MOZ',
  'NAM',
  'NIC',
  'NGA',
  'MNP',
  'PAK',
  'PSE',
  'PAN',
  'PER',
  'BLM',
  'KNA',
  'LCA',
  'WSM',
  'SEN',
  'SXM',
  'SOM',
  'SUR',
  'SJM',
  'TJK',
  'TZA',
  'TTO',
  'TKM',
  'UGA',
  'VUT',
  'ESH',
  'YEM',
  'ZWE'
]
